import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Button,
  ButtonGroup,
} from '@mui/material';

const HalfSelector = ({ currentHalf, setCurrentHalf }) => {
  const handleHalfChange = (half) => {
    setCurrentHalf(half);
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Select Half
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <ButtonGroup variant="outlined" aria-label="match halves">
          <Button
            variant={currentHalf === 1 ? 'contained' : 'outlined'}
            onClick={() => handleHalfChange(1)}
          >
            1st Half
          </Button>
          <Button
            variant={currentHalf === 2 ? 'contained' : 'outlined'}
            onClick={() => handleHalfChange(2)}
          >
            2nd Half
          </Button>
        </ButtonGroup>
      </Box>
    </Paper>
  );
};

export default HalfSelector;